import { render } from "./MarketplacePage.vue?vue&type=template&id=06715380&scoped=true"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"

import "./MarketplacePage.vue?vue&type=style&index=0&id=06715380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06715380"]])

export default __exports__